var map = {
	"./2021-p1.png": "8681",
	"./2021-p2.png": "0d71",
	"./2021-p3.png": "aff9",
	"./2021-p4.png": "cb0d",
	"./2021-p5.png": "7787",
	"./2021-p6.png": "8368"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6a90";